import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { to64decode } from 'src/app/helpers/base64';
import { getLanguageCookie } from 'src/assets/language';
import { MatTableDataSource } from '@angular/material/table';
import { BusinessSolutionsService } from 'src/app/services/business-solutions/business-solutions.service';
import { v4 } from "uuid";
import { sortArrayOfObjects } from 'src/app/helpers/sortArrayOfObjects';
import { AttachmentsService } from 'src/app/services/attachments/attachments.service';
import { addAlert, apiOfflineAsync } from 'src/app/layouts/pages/pages.component';
import { systemPermissionsNew } from 'src/app/helpers/systemPermissions';
import { CorporationService } from 'src/app/services/corporation/corporation.service';
import { CrmTreeService } from 'src/app/services/crm-tree/crm-tree.service';

export const arrayExtensions: string[] = ['pdf', 'ppt', 'pptx', 'pptm', 'doc', 'docx', 'odt', 'rtf', 'csv', 'txt', 'xml', 'json', 'xls', 'xlsx', 'jpeg', 'png', 'mpp', 'mpt']
@Component({
  selector: 'app-attachments',
  templateUrl: './attachments.component.html',
  styleUrls: ['./attachments.component.scss']
})
export class AttachmentsComponent {
  @Input() parameters: any = {}
  @Input() dimensions: any = {}

  @ViewChild('fileInput') fileInput!: ElementRef;
  that: any = {}

  formData: FormData = new FormData();

  dataSource!: MatTableDataSource<any>;
  displayedColumns: string[] = ['extension','surname', 'name', 'tab', 'type' ,'action'];

  currentPage = 1;
  currentPageReq = 1;
  itemsPerPage = 10;

  selectedFlag: any = {
    lang: 'en',
    file: 'us.svg'
  };
  isLoading: boolean = false
  tabArray: any = []
  typeArray: any = []

  searchTab: string = ''
  searchType: string = ''
  createType: boolean = false
  newType: any = {
    name: ''
  }
  constructor(
    private businessSolutionsService: BusinessSolutionsService,
    private attachmentsService: AttachmentsService,
    private corporationService: CorporationService,
    private crmTreeService: CrmTreeService
  ) {
    this.dataSource = new MatTableDataSource();
  }

  async ngOnInit(){
    if (this.parameters.item.attachments.length > 0) {
      this.dataSource = new MatTableDataSource<any>(this.parameters.item.attachments)
    }else{
      this.parameters.item.attachments = []
      this.dataSource = new MatTableDataSource<any>(this.parameters.item.attachments)
    }
    await this.getOptionsArray()
    await this.getCorporationTypeAttachment()
  }

  getNames(name: any){
    return name[to64decode(localStorage.getItem('language')).lang]
  }

  getSystemPermission(screen: string, action: string){
    return systemPermissionsNew(screen, action)
  }

  async getOptionsArray() {
    this.tabArray = this.parameters.optionsArray.tabArray
    // this.typeArray = this.parameters.optionsArray.attachmentsTypeEnum
    // if(this.getSystemPermission('business_solutions', 'create_type_attachment')){
    //   this.typeArray.unshift({name: 'New +'})
    // }
  }

  setThat() {
    this.that = this
  }

  getLanguages(file: string){
    return getLanguageCookie(file, localStorage.getItem('language'))
  }

  getCurrentLanguage() {
    return to64decode(localStorage.getItem('language'))?.lang
  }

  getTypeName(typeAttachment: string | null): string {
    if (!typeAttachment) return this.getLanguages('search')
    
    const type = this.typeArray.find((t: { uuid?: string; slug?: string }) => t.uuid === typeAttachment) || 
                 this.typeArray.find((t: { uuid?: string; slug?: string }) => t.slug === typeAttachment)
    
    if (type?.uuid) return type.name
    else if (type?.slug) return this.getLanguages('attachment/type/' + type.slug)
    else return this.getLanguages('search')
  }

  getDisplayedRowsAttachment(): any[]{
    const temp = this.dataSource.data.filter((item: any) => !item.is_delete);
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    const endIndex = startIndex + this.itemsPerPage;

    return [...temp].slice(startIndex, endIndex);
  }

  async handleFileInput(event: any) {
    const files = event.target.files;

    for (let i = 0; i < files.length; i++) {
      const file: File = files[i];

      let extension: any = file.name.split('.')
      extension = extension.pop()

      if(arrayExtensions.includes(extension.toLowerCase())){
        let row = {
          uuid: v4(),
          name: file.name,
          surname: file.name,
          file: file,
          is_create: true,
          is_delete: false,
          is_copied: false
        }
        await this.saveAttachment(row)
      }else{
        addAlert('orange', this.getLanguages('errors/invalidFormatInputAttachments'))
      }
    }
  }

  async saveAttachment(row: any, is_delete: boolean = false) {
    
    const index = this.dataSource.data.findIndex((item: any) => item.uuid == row.uuid);
    
    if (index >= 0) {
      if (is_delete) {
        row.is_delete = true;
        if (row.file == undefined) {
          this.parameters.attachments_deleted.push(row);
        }
      }
      
      // Se o anexo foi copiado, garante que o arquivo seja uma cópia válida
      if (row.is_copied && row.file) {
        try {
          // Cria uma nova cópia do arquivo
          const fileArray = await row.file.arrayBuffer();
          row.file = new File([fileArray], row.file.name, {
            type: row.file.type,
            lastModified: row.file.lastModified
          });
        } catch (error) {
          console.error('Erro ao copiar arquivo:', error);
        }
      }
      
      this.dataSource.data[index] = row;
    } else {
      // Se é um novo anexo copiado, garante que o arquivo seja uma cópia válida
      if (row.is_copied && row.file) {
        try {
          // Cria uma nova cópia do arquivo
          const fileArray = await row.file.arrayBuffer();
          row.file = new File([fileArray], row.file.name, {
            type: row.file.type,
            lastModified: row.file.lastModified
          });
        } catch (error) {
          console.error('Erro ao copiar arquivo:', error);
        }
      }
      
      this.dataSource.data.push(row);
    }
    
    this.parameters.item.attachments = this.dataSource.data;
    if(this.parameters.item.crmTree){
      await this.crmTreeService.setAttachmentArray(row);
    }else{
      await this.businessSolutionsService.setAttachmentArray(row);
    }
  }

  getClassIcon(name: string): string{
    let extension: any = name.split('.')
    extension = extension.pop()

    if (['png', 'jpg', 'jpeg', 'gif'].includes(extension)) return 'fa-regular fa-file-image'
    if (['mp4', 'avi'].includes(extension)) return 'fa-regular fa-file-video'
    if (['txt'].includes(extension)) return 'fa-regular fa-file-lines'
    if (['doc', 'docx'].includes(extension)) return 'fa-regular fa-file-word'
    if (['pdf'].includes(extension)) return 'fa-regular fa-file-pdf'
    if (['xls', 'xlsx'].includes(extension)) return 'fa-regular fa-file-excel'
    if (['pptx', 'ppt'].includes(extension)) return 'fa-regular fa-file-powerpoint'
    return 'fa-regular fa-file'
  }

  openFileInput() {
    this.fileInput.nativeElement.click();
  }

  async downloadAttachment(row: any) {
    this.isLoading = true;

    try {
      // Verifica se o anexo tem fullname (está salvo no servidor)
      if (row?.fullname) {
        this.attachmentsService.downloadAttachment(row.fullname).subscribe(response => {
          const blob = new Blob([response], { type: 'application/octet-stream' });
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = row.name;
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
          document.body.removeChild(a);
          this.isLoading = false;
        }, error => {
          console.error('Erro ao baixar do servidor:', error);
          addAlert('orange', this.getLanguages('errors/attachmentsNotFound'));
          this.isLoading = false;
        });
      } 
      // Verifica se é um anexo copiado e tem o arquivo original
      else if (row?.is_copied && row?.file) {
        try {
          // Tenta criar um novo Blob a partir do arquivo
          const blob = new Blob([row.file], { type: row.file.type || 'application/octet-stream' });
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = row.name || row.file.name || 'arquivo';
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
          document.body.removeChild(a);
          this.isLoading = false;
        } catch (error) {
          console.log('Erro ao criar Blob do arquivo copiado:', error);
          addAlert('orange', this.getLanguages('errors/attachmentsNotFound'));
          this.isLoading = false;
        }
      }
      // Verifica se o anexo tem um arquivo válido (não salvo ainda)
      else if (row?.file instanceof File || row?.file instanceof Blob) {
        const url = window.URL.createObjectURL(row.file);
        const a = document.createElement('a');
        a.href = url;
        a.download = row.name || row.file.name || 'arquivo';
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
        this.isLoading = false;
      }
      // Se nenhuma das condições anteriores for atendida
      else {
        addAlert('orange', this.getLanguages('errors/attachmentsNotFound'));
        console.log('Anexo não encontrado:', row);
        this.isLoading = false;
      }
    } catch (error) {
      addAlert('orange', this.getLanguages('errors/attachmentsNotFound'));
      console.error('Erro ao baixar anexo:', error);
      this.isLoading = false;
    }
  }

  choseTab(attachment: any, tab: any){
    attachment.tab = tab.slug
  }

  choseType(attachment: any, type: any){
    if(type.name == "New +"){
      this.createType = true;
      return
    }
    attachment.typeAttachment = type.uuid ? type.uuid : type.slug
  }

  async getCorporationTypeAttachment(event?: any) {
    try {
      const response: any = await this.corporationService.getCorporationTypeAttachment();
      if (response && response.data) {
        let tempArray = response.data
        tempArray = tempArray.filter((item: any) => item.name && item.uuid)
          .map((item: any) => ({
            name: item.name,
            uuid: item.uuid
          }))
        
        this.typeArray = [...this.parameters.optionsArray.attachmentsTypeEnum, ...tempArray];

        if(this.getSystemPermission('business_solutions', 'create_type_attachment')){
          this.typeArray.unshift({name: 'New +'})
        }

      } else {
        throw new Error('Erro ao consultar tipos de anexos!\nConsulta o administrador do sistema!');
      }
    } catch (error: any) {
      await apiOfflineAsync(error)
    }
  }

  async setCorporationTypeAttachment(){
    let flag = false;

    this.typeArray.forEach((item: any) => {
      if(item.name == this.newType.name){
        addAlert('orange', this.getLanguages('businessSolution/modal/rules/errors/typeAttachment'))
        flag = true
        return
      }
    });

    if(flag){
      return
    }
    
    if(this.newType.name == 'New +'){
      addAlert('danger', this.getLanguages('auth/alert/nameReservedWord'))
      return
    }

    try {
      const response:any = await this.corporationService.setCorporationTypeAttachment(this.newType);
      if (response && [201, 202].includes(response.status) ) {
        addAlert('success', response.message)
        await this.getCorporationTypeAttachment();
      } else {
        addAlert('danger', response.message)
      }
    } catch (error: any) {
      await apiOfflineAsync(error)
    }
    this.createType = false;
    this.newType.name = ''
  }
}
